// Android WebView Telegram Mini App: native-bridge (TelegramWebviewProxy.postEvent)
// бросает синхронно, если Java-объект уже уничтожен или метод не найден.
// Без ловли ошибка уходит в React ErrorBoundary и срывает старт.

const TELEGRAM_BRIDGE_ERROR_MARKERS = [
  'Java bridge method invocation error',
  'Java object is gone',
  'Error invoking postEvent',
  'Method not found',
] as const

export function isTelegramBridgeErrorMessage(text: string): boolean {
  return TELEGRAM_BRIDGE_ERROR_MARKERS.some((marker) => text.includes(marker))
}

export function safeTelegramCall(fn: () => void): void {
  try {
    fn()
  } catch {
    // no-op: ошибка моста не должна ронять UI
  }
}
